import { MainHero } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import { getCdnImg } from 'utils/getters'
import styles from './СalloutBox.module.scss'

const СalloutBox = ({ webpart: { titleRTE, description, backgroundColor, image, imageOnLeftSize = true } }) => (
  <section className={styles.СalloutBox}>
    <MainHero
      title={titleRTE}
      subtitle={description}
      background={backgroundColor}
      image={getCdnImg(image, 588)}
      imagePosition={imageOnLeftSize ? 'left' : 'right'}
      imageSize="auto"
    />
  </section>
)

СalloutBox.propTypes = {
  webpart: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    backgroundColor: PropTypes.string,
    image: PropTypes.string,
    titleRTE: PropTypes.string,
    imageOnLeftSize: PropTypes.bool
  })
}

СalloutBox.defaultProps = {
  webpart: {
    title: PropTypes.string,
    description: '',
    backgroundColor: '#00993F',
    image: '',
    titleRTE: '',
    imageOnLeftSize: true
  }
}

export default СalloutBox
